export default __webpack_public_path__ + "3de987084b51bd765916d5b6eedcaee0.jpg";